import React from 'react';
import {
  Whisper,
  Tooltip,
} from 'rsuite';
const WhatsApp = ({ rowData, imger }) => {
  return (

    <Whisper followCursor speaker={<Tooltip>WhatsApp</Tooltip>}>
      <a
        href={
          rowData?.attributes?.Glink
            ? `https://api.whatsapp.com/send/?text=${rowData.attributes.Glink}&type=custom_url&app_absent=0`
            : '#'
        }
      >
        <img
          src={imger} // Replace 'path_to_your_whatsapp_icon.svg' with the actual path to your WhatsApp SVG icon
          alt="WhatsApp"
          style={{
            width: '30px',
            height: '30px',
            color: 'green',
            cursor: 'pointer'
          }}
        />
      </a>
    </Whisper>

  );
};

export default WhatsApp;
